/**
 * Function used to convert UTC string to 12 hour time format with seconds
 * @param {string} time24 - UTC Date string in "HH:mm:ss" format
 * @returns {string} formatted time string
 */
function FormatUtcStringWithSeconds(time24: string): string {
  if (!time24) {
    console.error('Invalid UTC string provided:', time24);
    return '';
  }

  // Destructure hours, minutes, and seconds directly from time24
  const parts = time24.split(':');
  const hours24 = Number(parts[0]);
  const minutes = parts[1] || '00';
  const seconds = parts[2] || '00';

  // Determine the period (AM/PM)
  const period = hours24 >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  const hours12 = hours24 % 12 || 12;

  // Return the formatted time
  return `${hours12}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} ${period}`;
}

export default FormatUtcStringWithSeconds;
